import { BlockComponentFactory } from '../BlockFactory'
import Switch from 'antd/lib/switch'
import { ToggleBlockProps } from './block-props.types'
import { LabelBlock } from './LabelBlock'
import { LABEL_FONT_STYLE } from '../../constants'
import Flex from 'antd/lib/flex'
import { useBlockListeners } from '../BlockHooks'
import { useBlockEngine } from '../BlockEngineContext'

export const ToggleBlockComponent = BlockComponentFactory.createBlockComponent<ToggleBlockProps>(
    props => {
        const { label, disabled = false, infoText, visibility = 'visible', style, value } = props

        const isEditable = useBlockEngine().blockEngine.getEditableSignal().value

        const [onChangeListener] = useBlockListeners<(value: boolean) => void>('onChange')

        const containerStyle: React.CSSProperties = {
            ...style,
            display: visibility === 'hidden' ? 'none' : 'block',
        }

        return (
            <div style={containerStyle}>
                <Flex align="center" gap="8px">
                    <LabelBlock label={label} infoText={infoText} labelStyle={LABEL_FONT_STYLE} />
                    <Switch
                        disabled={!isEditable || disabled}
                        checked={value}
                        onChange={value => onChangeListener?.value?.(value)}
                    />
                </Flex>
            </div>
        )
    }
)
